import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IDriver, IPayloadDriver, IResponseModel } from '@core/interface';
import { SchedulingModalityEnum } from '@core/enums';
import { finalize, firstValueFrom, Observable, switchMap } from 'rxjs';
import { NewScheduleService } from '@agenda-customer-ui/data-access';
import { DriverLoadingComponent } from '../../../loading/shimmer/schedule/open-card/driver/driver-loading.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-driver-information',
  standalone: true,
  imports: [CommonModule, TranslateModule, DriverLoadingComponent],
  templateUrl: './driver-information.component.html',
  styleUrls: ['./driver-information.component.scss'],
})
export class DriverInformationComponent implements OnInit {
  private scheduleService = inject(NewScheduleService);

  showNotFoundContent = input<boolean>(true);
  modality = input.required<string>();
  modalityEnum = SchedulingModalityEnum;

  payloadDriver = input.required<IPayloadDriver>();
  driverData$!: Observable<IResponseModel<IDriver>>;
  imageSignal = signal('./assets/lib/images/Avatar.png');

  loadingDriver = signal(true);

  hasDriverAssosiated = output<boolean>();
  loadingDriverOutput = output<boolean>();

  ngOnInit(): void {
    this.driverData$ = this.scheduleService.getDriverSchedule(this.payloadDriver()).pipe(
      switchMap(async data => {
        const { advisorDriverImage } = data?.response ?? {};
        this.hasDriverAssosiated.emit(!!data?.response);
        if (advisorDriverImage) {
          this.imageSignal.set(await firstValueFrom(this.scheduleService.getImageDriverSchedule(advisorDriverImage)));
        }
        return data;
      }),
      finalize(() => {
        this.loadingDriverOutput.emit(false);
        this.loadingDriver.set(false);
      })
    );
  }
}
